/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {

    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
              {
                path: '/',
                name: 'home',
                component: () => import('./views/dashboard/Home.vue'),
                meta: {
                  requiresAuth: true
                }
              },

              {
                path: '/users',
                name: 'users',
                component: () => import('./views/dashboard/users/Show.vue'),
                meta: {
                  requiresAuth: true
                }
              },

              {
                path: '/orders',
                name: 'orders',
                component: () => import('./views/dashboard/orders/Orders.vue'),
                meta: {
                  requiresAuth: true
                }
              },

              {
                path: '/factors',
                name: 'factors',
                component: () => import('./views/dashboard/factors/Show.vue'),
                meta: {
                  requiresAuth: true
                }
              },

              {
                path: '/posts',
                name: 'posts',
                component: () => import('./views/dashboard/posts/Posts.vue'),
                meta: {
                  requiresAuth: true
                }
              },

              {
                path: '/EditProfile',
                name: 'editProfile',
                component: () => import('./views/dashboard/EditProfile.vue'),
                meta: {
                  requiresAuth: true
                }
              //   meta: {
              //     breadcrumb: [
              //         { title: 'Home', url: '/' },
              //         { title: 'Pages' },
              //         { title: 'Profile', active: true },
              //     ],
              //     pageTitle: 'Profile',
              //     rule: 'editor'
              // },
              },

              {
                path: '/warranties',
                name: 'warranties',
                component: () => import('./views/dashboard/warranties/Show.vue'),
                meta: {
                  requiresAuth: true
                }
              },
            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/pages/login',
                name: 'page-login',
                component: () => import('@/views/pages/Login.vue')
              },
              {
                path: '/pages/resetPassword',
                name: 'page-resetPassword',
                component: () => import('@/views/pages/ResetPassword.vue')
              },
              {
                path: '/chat/messages',
                name: 'page-chat',
                component: () => import('@/views/pages/chat/Chat.vue'),
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue')
              },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem("token")) {
      next({ name: 'page-login' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
